/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DownloadAndSignOptionsSection
 */
export interface DownloadAndSignOptionsSection {
    /**
     * 
     * @type {boolean}
     * @memberof DownloadAndSignOptionsSection
     */
    includeSection: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DownloadAndSignOptionsSection
     */
    disableSection: boolean;
    /**
     * 
     * @type {number}
     * @memberof DownloadAndSignOptionsSection
     */
    individualSectionCount: number;
    /**
     * 
     * @type {number}
     * @memberof DownloadAndSignOptionsSection
     */
    trustSectionCount: number;
    /**
     * 
     * @type {number}
     * @memberof DownloadAndSignOptionsSection
     */
    companySectionCount: number;
}

/**
 * Check if a given object implements the DownloadAndSignOptionsSection interface.
 */
export function instanceOfDownloadAndSignOptionsSection(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "includeSection" in value;
    isInstance = isInstance && "disableSection" in value;
    isInstance = isInstance && "individualSectionCount" in value;
    isInstance = isInstance && "trustSectionCount" in value;
    isInstance = isInstance && "companySectionCount" in value;

    return isInstance;
}

export function DownloadAndSignOptionsSectionFromJSON(json: any): DownloadAndSignOptionsSection {
    return DownloadAndSignOptionsSectionFromJSONTyped(json, false);
}

export function DownloadAndSignOptionsSectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): DownloadAndSignOptionsSection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'includeSection': json['IncludeSection'],
        'disableSection': json['DisableSection'],
        'individualSectionCount': json['IndividualSectionCount'],
        'trustSectionCount': json['TrustSectionCount'],
        'companySectionCount': json['CompanySectionCount'],
    };
}

export function DownloadAndSignOptionsSectionToJSON(value?: DownloadAndSignOptionsSection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'IncludeSection': value.includeSection,
        'DisableSection': value.disableSection,
        'IndividualSectionCount': value.individualSectionCount,
        'TrustSectionCount': value.trustSectionCount,
        'CompanySectionCount': value.companySectionCount,
    };
}

